import { Location } from 'history';
import isNumber from 'lodash-es/isNumber';
import { ADMINCLUB_MENU, CONFIRM, DELETE, GROUP_REPORTED_POSTS } from 'mk/autogenerated/translations/GroupFeedPage.82a45a2128eff938d5c64247c91ec78c'
import { isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import { adminclub_group_url } from 'mk/urls/functions';
import { analyticsStoreEvent } from 'mk2/actions';
import { BlogPostFormData } from 'mk2/apps/blogs/components/BlogPostCreateForm';
import { BoxedHashtags } from 'mk2/apps/blogs/components/HashtagsBox';
import LeftMenu from 'mk2/apps/blogs/components/LeftMenu';
import commentsSaga from 'mk2/apps/blogs/containers/Comments/Comments.sagas';
import { BLOG_POST_COMMENT_MENU_MORE, BLOG_POST_MENU_MORE } from 'mk2/apps/blogs/helpers';
import {
    BlogPostEntity,
    BlogPostSchema,
    GroupEntity,
    GroupMemberEntity,
    GroupMemberSchema,
    GroupSchema,
    UsersByGroupId,
} from 'mk2/apps/blogs/schemas';
import { PageRef } from 'mk2/apps/forum/schemas';
import { hasMergedForumAndGroups, parsePageNumber } from 'mk2/apps/forum/utils';
import {
    GROUP_COVER_MENU_MORE,
    GROUP_COVER_UPLOAD_FORM_NAME,
    GroupCoverFormData,
} from 'mk2/apps/groups/components/GroupCoverForm';
import { emptyComplaintsCounts } from 'mk2/apps/groups/containers/GroupReportedFeed/GroupReportedFeed.constants';
import {
    groupSharedDeleteGroupPostCommentInit,
    groupSharedDeleteGroupPostInit,
    groupSharedFeedRead,
    groupSharedInviteUser,
    groupSharedJoinGroup,
    groupSharedLeaveGroup,
    groupSharedPostSticky,
    groupSharedSetGroupAsFavorite,
    groupSharedSubscribeGroup,
} from 'mk2/apps/groups/containers/GroupShared/GroupShared.actions';
import groupSharedReducer from 'mk2/apps/groups/containers/GroupShared/GroupShared.reducers';
import groupSharedSaga from 'mk2/apps/groups/containers/GroupShared/GroupShared.sagas';
import {
    getCommentComplaintsCounts,
    getGroupSharedState,
    getModeratorUsersByGroupId,
    getPostsCommentsCount,
} from 'mk2/apps/groups/containers/GroupShared/GroupShared.selectors';
import { groupsGroupReportedUrl } from 'mk2/apps/groups/urls';
import Btn, { BtnLayout, BtnType } from 'mk2/components/Btn';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import MenuItem from 'mk2/components/menu/MenuItem';
import { Count } from 'mk2/components/NotificationsBadge';
import { FormPageType } from 'mk2/constants';
import { AppName } from 'mk2/containers/Application/Application';
import { complaintInitToggle } from 'mk2/containers/Complaint/Complaint.actions';
import { ComplaintTargetType } from 'mk2/containers/Complaint/Complaint.schemas';
import { getComplaintsShownForBlogPosts } from 'mk2/containers/Complaints/Complaints.selectors';
import Menu from 'mk2/containers/Menu/Menu';
import { menuToggle } from 'mk2/containers/Menu/Menu.actions';
import { PhotosUploadConfig } from 'mk2/containers/PhotosUpload/PhotosUpload';
import { cacheLast, memoizeOne } from 'mk2/helpers/cache';
import { UserAgentParsed } from 'mk2/helpers/detects';
import { mkReduxFormMapDispatchToProps, mkReduxFormMapStateToProps } from 'mk2/helpers/form';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import FormPage, { FormPageDispatchProps, FormPageStateProps } from 'mk2/pages/FormPage';
import { BrandingProps, HalfpageProps, RightContentSide } from 'mk2/pages/Page';
import {
    AppState,
    getRequestBaseUrl,
    getRequestDeviceIsIOS,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
    getRequestUserAgent,
} from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { MenuSelection, UserEntity } from 'mk2/schemas';
import { getDenormalizedEntities, getDenormalizedEntity } from 'mk2/selectors';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import GroupFeed from './GroupFeed';
import {
    groupCoverRemoveTrigger,
    groupCoverSubmitTrigger,
    groupCoverUploadTrigger,
    groupDeleteGroup,
    groupFeedFetchTrigger,
    groupFeedScrollToTrigger,
    groupPostCreateTrigger,
} from './GroupFeed.actions';
import { GROUP_FEED_MENU_MORE, GROUP_FEED_MENU_ORDERBY } from './GroupFeed.constants';
import reducer, {
    GroupFeedPageState,
    GroupFeedVirtualPageState,
    initialGroupFeedPageState,
} from './GroupFeed.reducers';
import saga from './GroupFeed.sagas';
import {
    getGroupFeedPageState,
    getGroupFeedSearchState,
    getGroupFeedState,
    getGroupFeedVirtualPageState,
    getGroupLastVisitedCount,
} from './GroupFeed.selectors';
import styles from './GroupFeedPage.mscss';

export enum ScrollToPosition {
    FirstPost = 'first',
    LastPost = 'last',
}

export type OrderBy = 'comments' | 'posts';

interface OwnProps {}

interface StateProps extends FormPageStateProps {
    askedForMembership: number[];
    baseUrl: string;
    commentsCounts: { [postId: number]: number };
    complaintsCounts: { [postId: number]: number };
    complaintsOpened: boolean[];
    count: number;
    errorMessage: string;
    group: GroupEntity;
    groupId: number;                // extracted from 'match.params.groupId'
    hasComplaints: boolean;
    hashtags: BoxedHashtags;
    initialValues: BlogPostFormData;
    isBlocked: boolean;
    isFavorite: boolean;
    isIOS: boolean;
    isMember: boolean;
    isModerator: boolean;
    isSubscribed: boolean;
    isSubscribing: boolean;
    joining: number[];
    lastVisitedCount: Count;
    loadingState: LoadingState;
    memberships: number[];
    mobile: boolean;
    moderators: GroupMemberEntity[];
    moderatorUsersByGroupId: UsersByGroupId;
    numberOfPages: number;
    orderBy: OrderBy;
    pageRef: PageRef;
    permissions: string[];
    posts: BlogPostEntity[];
    query: string;
    requestUser: UserEntity;
    userAgent: UserAgentParsed;
}

interface DispatchProps extends FormPageDispatchProps {
    onAddPost(groupId: number, pageRef: PageRef, values: BlogPostFormData);
    onChangeSticky(postId: number, sticky: boolean);
    onCommentDelete(commentId: number, key: string);
    onCommentToggleMenuMore(commentId: number);
    onDelete(postId: number);
    onFeedRead(groupId: number);
    onGroupAddToFavorites(groupId: number, userId: number);
    onGroupCoverRemove(groupId: number);
    onGroupCoverSave(values: GroupCoverFormData, groupId: number);
    onGroupCoverToggleMenuMore();
    onGroupDelete(groupId: number);
    onGroupFeedMenuOrderBy();
    onGroupJoin(groupId: number, origin: string);
    onGroupLeave(groupId: number);
    onGroupSubscribe(groupId: number, username: string);
    onGroupRemoveFromFavorites(groupId: number, userId: number);
    onGroupToggleMenuMore();
    onGroupUnsubscribe(groupId: number, username: string);
    onInviteUser(groupId: number);
    onLoad(groupId: number, pageRef: PageRef, orderBy: OrderBy, query: string, currentUrl: Location, numCommentsBeforeLoad: number);
    onPostToggleMenuMore(postId: number);
    onReport(entity: ComplaintTargetType, id: number);
    onScrollTo(scrollto: ScrollToPosition);
    onStoreEvent(name: string, props: any);
    onUploadFiles(groupId: number, config: PhotosUploadConfig, files: File[]);
}

type RouteProps = RouteComponentProps<{
    groupId: string;
}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

interface Query {
    orderby: OrderBy;
    query: string;
}

const initialValues = {
    text: '',
    photos: [],
    sticker: null,
};

export default class GroupFeedPage extends FormPage<OwnProps & RouteProps, StateProps, DispatchProps> {

    private onDeleteCache = cacheLast();
    private headerRightCache = cacheLast();
    private oldMenuSelection = {
        activeSection: 'photoblog',
        activeItem: 'groups',
    };
    private newMenuSelection = {
        activeSection: 'groups',
        activeItem: 'feed',
    };

    private parseQuery = memoizeOne((qs: string): Query => {
        const qp = parse(qs) || {};
        return {
            // empty string value is considered correct too and needs to be preserved as such
            orderby: qp.orderby || 'posts',
            query: (qp.query !== undefined) ? qp.query : null,
        };
    });

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const { match: { params } } = ownProps;
            const groupId = parseInt(params.groupId, 10);
            const parsedQuery: Query = this.parseQuery(ownProps.location.search);
            const query = parsedQuery.query;
            const orderBy = parsedQuery.orderby;

            const pageRef = parsePageNumber(ownProps.location);

            const groupSharedState = getGroupSharedState(state);
            const groupFeedState = getGroupFeedState(state, groupId);
            const groupPostsState = getGroupFeedSearchState(state, groupId, orderBy, query);

            const group = getDenormalizedEntity<GroupEntity>(state, GroupSchema, groupId);
            const moderators = getDenormalizedEntities<GroupMemberEntity>(state, GroupMemberSchema, groupFeedState.moderators);
            const moderatorUsers = moderators.map((groupMember) => groupMember.user);

            const permissions = getRequestPermissions(state);
            const requestUser = getRequestUser(state);
            const userAgent = getRequestUserAgent(state);

            const isAdmin = permissions.indexOf('forum.can_manage_forum') >= 0;
            const isModerator = moderatorUsers && isAuthenticatedAs(requestUser, moderatorUsers);

            const groupFeedPageState: GroupFeedPageState | GroupFeedVirtualPageState = isNumber(pageRef)
                ? getGroupFeedPageState(state, groupId, orderBy, query, pageRef)
                : getGroupFeedVirtualPageState(state, groupId, orderBy, query, pageRef);

            const postIds = isNumber(pageRef)
                ? (groupFeedPageState as GroupFeedPageState).postIds
                : initialGroupFeedPageState.postIds;

            const posts = getDenormalizedEntities<BlogPostEntity>(state, BlogPostSchema, postIds);

            const memberships = groupSharedState.memberships;

            const commentsLoadingState = groupFeedState.commentsLoadingState;

            const commentsCounts = getPostsCommentsCount(state, posts);

            const complaintsCounts = (isAdmin || isModerator)
                ? getCommentComplaintsCounts(state, postIds, commentsLoadingState)
                : emptyComplaintsCounts;

            const lastVisitedCount = getGroupLastVisitedCount(state, groupId);

            return {
                ...mkReduxFormMapStateToProps(GROUP_COVER_UPLOAD_FORM_NAME)(state),
                askedForMembership: groupSharedState.askedForMembership,
                baseUrl: getRequestBaseUrl(state),
                commentsCounts,
                complaintsCounts,
                complaintsOpened: getComplaintsShownForBlogPosts(state, posts),
                count: groupPostsState.count,
                errorMessage: groupFeedPageState.errorMessage,
                group,
                groupId,
                hasComplaints: groupFeedState.hasComplaints,
                hashtags: groupFeedState.hashtags,
                initialValues,
                isBlocked: groupFeedState.isBlocked,
                isFavorite: groupSharedState.favorites.includes(groupId),
                isIOS: getRequestDeviceIsIOS(state),
                isMember: memberships.includes(groupId),
                isModerator,
                isSubscribed: groupFeedState.isSubscribed,
                isSubscribing: groupFeedState.isSubscribing,
                joining: groupSharedState.joining,
                lastVisitedCount,
                loadingState: groupFeedPageState.loadingState,
                memberships,
                mobile: getRequestDeviceMobile(state),
                moderators,
                moderatorUsersByGroupId: getModeratorUsersByGroupId(moderators),
                numberOfPages: groupPostsState.numberOfPages,
                orderBy,
                pageRef,
                permissions,
                posts,
                query,
                requestUser,
                userAgent,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            ...mkReduxFormMapDispatchToProps(GROUP_COVER_UPLOAD_FORM_NAME),
            onAddPost: groupPostCreateTrigger,
            onChangeSticky: groupSharedPostSticky,
            onCommentDelete: groupSharedDeleteGroupPostCommentInit,
            onCommentToggleMenuMore: (commentId: number) => menuToggle(BLOG_POST_COMMENT_MENU_MORE(commentId)),
            onDelete: groupSharedDeleteGroupPostInit,
            onFeedRead: groupSharedFeedRead,
            onGroupAddToFavorites: (groupId, userId) => groupSharedSetGroupAsFavorite(groupId, userId, true),
            onGroupCoverRemove: groupCoverRemoveTrigger,
            onGroupCoverSave: (values: GroupCoverFormData, groupId: number) => groupCoverSubmitTrigger(values, groupId),
            onGroupCoverToggleMenuMore: () => menuToggle(GROUP_COVER_MENU_MORE),
            onGroupDelete: groupDeleteGroup,
            onGroupFeedMenuOrderBy: () => menuToggle(GROUP_FEED_MENU_ORDERBY),
            onGroupJoin: groupSharedJoinGroup,
            onGroupLeave: (groupId) => groupSharedLeaveGroup(groupId, true),
            onGroupSubscribe: (groupId, username) => groupSharedSubscribeGroup(groupId, username, true),
            onGroupRemoveFromFavorites: (groupId, userId) => groupSharedSetGroupAsFavorite(groupId, userId, false),
            onGroupToggleMenuMore: () => menuToggle(GROUP_FEED_MENU_MORE),
            onGroupUnsubscribe: (groupId, username) => groupSharedSubscribeGroup(groupId, username, false),
            onInviteUser: groupSharedInviteUser,
            onLoad: groupFeedFetchTrigger,
            onPostToggleMenuMore: (postId: number) => menuToggle(BLOG_POST_MENU_MORE(postId)),
            onReport: (entity: string, id: number) => complaintInitToggle(entity, id, true),
            onScrollTo: groupFeedScrollToTrigger,
            onStoreEvent: analyticsStoreEvent,
            onUploadFiles: groupCoverUploadTrigger,
        };
    }

    public getMetaTitle(props: Props): string {
        const { group } = props;
        return group ? group.name : null;
    }

    public getMetaDescription(props: Props): string {
        const { group } = props;
        return group ? group.description : null;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <GroupFeed key={props.query} {...props} />
        );
    }

    public renderRight(props: Props): JSX.Element {
        const { location } = props;
        return (
            <LeftMenu location={location} />
        );
    }

    public getRightContentSide(app: AppName, props: Props): RightContentSide {
        return RightContentSide.LeftSide;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        return {
            zone: 'Groups Feed - Halfpage Sticky (Desktop)',
        };
    }

    public getBrandingProps(props: Props): BrandingProps {
        return {
            zone: 'Groups - Branding',
        };
    }

    public getHeaderLeft(props: Props): React.ReactNode {
        const { currentFormPage, onCancelFormPage } = props;
        if (currentFormPage === FormPageType.ChangeGroupCover) {
            return (
                <Btn
                    layout={BtnLayout.Icon}
                    onClick={onCancelFormPage}
                    icon="fa-times"
                />
            );
        } else {
            return super.getHeaderLeft(props);
        }
    }

    public getHeaderRight(props: Props): React.ReactNode {
        const {
            currentFormPage, group, hasComplaints, isModerator,
            permissions, onGroupDelete, onGroupToggleMenuMore,
        } = props;

        const isDeleted = group && group.deletedAt;
        if (isDeleted) {
            return null;
        }

        const isAdmin = permissions.indexOf('forum.can_manage_forum') >= 0;

        const isChangeGroupCoverFormPage = currentFormPage === FormPageType.ChangeGroupCover;

        let addBtn = null;
        if (isChangeGroupCoverFormPage) {
            addBtn = (isAdmin || isModerator) ? (
                <SubmitButton
                    key="btn"
                    label={CONFIRM}
                    formName={GROUP_COVER_UPLOAD_FORM_NAME}
                />
            ) : null;
        }

        const role = isAdmin ? 'admin' : (isModerator ? 'moderator' : '');
        let menu;
        if ((isModerator || isAdmin) && !isChangeGroupCoverFormPage) {
            const hasDelete = false && isAdmin && group;    // TBD
            const hasAdminclub = group && isAdmin;
            menu = (
                <Menu
                    key="menu"
                    menuId={GROUP_FEED_MENU_MORE}
                    trigger={
                        <Btn
                            type={BtnType.BlueOutline}
                            icon="fa-cog fa-lg"
                            onClick={onGroupToggleMenuMore}
                            bullet={hasComplaints}
                            bulletClassName={styles.GroupFeedPage__menu__trigger__bullet}
                        />
                    }
                >
                    {hasComplaints && (
                        <MenuItem
                            label={GROUP_REPORTED_POSTS}
                            icon="fa-exclamation-triangle"
                            className={styles[`GroupFeedPage__menu__item--${role}`]}
                            link={url(groupsGroupReportedUrl, { groupId: group.id })}
                            isAdminUI={!isModerator && isAdmin}
                        />
                    )}
                    {hasDelete && (
                        <MenuItem
                            label={DELETE}
                            icon="fa-trash"
                            onClick={this.onDeleteCache(() => {
                            onGroupDelete(group.id);
                        }, group.id)}
                            isAdminUI
                        />
                    )}
                    { hasAdminclub && (
                        <MenuItem
                            label={ADMINCLUB_MENU}
                            icon="fa-life-ring"
                            link={adminclub_group_url(group.id)}
                            asAnchor
                            isAdminUI
                        />
                    )}
                </Menu>
            );
        }

        return this.headerRightCache(
            [menu, '\u00A0\u00A0', addBtn],
            currentFormPage,
            group,
            hasComplaints,
            isModerator,
            permissions,
            onGroupDelete,
            onGroupToggleMenuMore,
        );
    }

    public getSubmitButton(props: Props): React.ReactNode {
        return null;
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return hasMergedForumAndGroups(props.requestUser) ? this.newMenuSelection : this.oldMenuSelection;
    }

    public hasMergedForumAndGroups(props: Props): boolean {
        return hasMergedForumAndGroups(props.requestUser);
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.groups.groupFeed', reducer);
        store.injectSaga('containers.groups.groupFeed', saga);

        store.injectReducer('containers.groups.groupShared', groupSharedReducer);
        store.injectSaga('containers.groups.groupShared', groupSharedSaga);

        store.injectSaga('containers.blogs.shared.comments', commentsSaga);
    }

}
